import React, { useEffect, useState } from 'react';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Collapse from '@material-ui/core/Collapse';
import { MuiPickersUtilsProvider, DatePicker } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import ptBrLocale from 'date-fns/locale/pt-BR';
import { PieChart, Pie, Cell, Legend } from 'recharts';
import moment from 'moment';
import { COLORS } from '../../consts/common';
import { formatMoney } from '../../utils/common';

const RADIAN = Math.PI / 180;

const renderMoneyLabel = ({
  cx,
  cy,
  midAngle,
  outerRadius,
  percent,
  value,
  fill,
}) => {
  if (percent <= 0.05) {
    return <text />;
  }

  const sin = Math.sin(-RADIAN * midAngle);
  const cos = Math.cos(-RADIAN * midAngle);
  const mx = cx + (outerRadius + 30) * cos;
  const my = cy + (outerRadius + 30) * sin;
  const ex = mx + (cos >= 0 ? 1 : -1) * 22;
  const ey = my;
  const textAnchor = cos >= 0 ? 'start' : 'end';
  const sx = cx + (outerRadius + 10) * cos;
  const sy = cy + (outerRadius + 10) * sin;

  return (
    <>
      <path
        d={`M${sx},${sy}L${mx},${my}L${ex},${ey}`}
        stroke={fill}
        fill="none"
      />
      <circle cx={ex} cy={ey} r={2} fill={fill} stroke="none" />
      <text
        x={ex + (cos >= 0 ? 1 : -1) * 12}
        y={ey}
        textAnchor={textAnchor}
        fill="#333"
      >
        {formatMoney(value / 100)}
      </text>
      <text
        x={ex + (cos >= 0 ? 1 : -1) * 12}
        y={ey}
        dy={18}
        textAnchor={textAnchor}
        fill="#999"
      >
        {`${(percent * 100).toFixed(2)}%`}
      </text>
    </>
  );
};

const renderGenericLabel = ({
  cx,
  cy,
  midAngle,
  outerRadius,
  percent,
  value,
  fill,
}) => {
  if (percent <= 0.05) {
    return <text />;
  }

  const sin = Math.sin(-RADIAN * midAngle);
  const cos = Math.cos(-RADIAN * midAngle);
  const mx = cx + (outerRadius + 30) * cos;
  const my = cy + (outerRadius + 30) * sin;
  const ex = mx + (cos >= 0 ? 1 : -1) * 22;
  const ey = my;
  const textAnchor = cos >= 0 ? 'start' : 'end';
  const sx = cx + (outerRadius + 10) * cos;
  const sy = cy + (outerRadius + 10) * sin;

  return (
    <>
      <path
        d={`M${sx},${sy}L${mx},${my}L${ex},${ey}`}
        stroke={fill}
        fill="none"
      />
      <circle cx={ex} cy={ey} r={2} fill={fill} stroke="none" />
      <text
        x={ex + (cos >= 0 ? 1 : -1) * 12}
        y={ey}
        textAnchor={textAnchor}
        fill="#333"
      >
        {value}
      </text>
      <text
        x={ex + (cos >= 0 ? 1 : -1) * 12}
        y={ey}
        dy={18}
        textAnchor={textAnchor}
        fill="#999"
      >
        {`${(percent * 100).toFixed(2)}%`}
      </text>
    </>
  );
};

function Pizza({
  updateValue,
  getInfoUsers,
  title,
  data,
  date,
  nomeLegenda,
  dk,
  type,
}) {
  useEffect(() => {
    const d = date || moment().format('YYYY-MM-DD HH:mm:ss');
    updateValue(d);
  }, []);

  return (
    <Grid container direction="row" justify="center" alignItems="center">
      <Box borderRadius={16}>
        <Grid
          container
          direction="row"
          justify="space-between"
          alignItems="center"
        >
          <Grid item>
            <Typography variant="h5" gutterBottom>
              {title}
            </Typography>
          </Grid>
          <Collapse in={date}>
            <Grid item>
              <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ptBrLocale}>
                <DatePicker
                  views={['year', 'month']}
                  label="Mês/Ano"
                  format="MM/yyyy"
                  value={date}
                  onChange={(d) => updateValue(d)}
                  InputAdornmentProps={{ position: 'start' }}
                  inputVariant="outlined"
                />
              </MuiPickersUtilsProvider>
            </Grid>
          </Collapse>
        </Grid>
        <PieChart width={550} height={400}>
          <Legend />
          <Pie
            data={data}
            labelLine={false}
            label={type === 'money' ? renderMoneyLabel : renderGenericLabel}
            dataKey={dk}
            nameKey={nomeLegenda}
            isAnimationActive={false}
            onClick={(p) => {
              if (getInfoUsers) {
                const id_usuario = p && p.payload ? p.payload.id_usuario : [];
                getInfoUsers(id_usuario);
              }
            }}
          >
            {data.map((entry, index) => (
              <Cell
                key={`cell-${index}`}
                fill={COLORS[index % COLORS.length]}
              />
            ))}
          </Pie>
        </PieChart>
      </Box>
    </Grid>
  );
}

export default Pizza;
